import { type HttpResponse } from '@wix/yoshi-flow-editor';
import { getPostFeedPage } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page-http/http';
import {
  FeedType,
  type GetPostFeedPageResponse,
} from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page-http/types';
import { createAction } from '@wix/communities-blog-client-common';
import { type FeedPageThunkAction } from '../../feed-page/types';
import { normalizePosts } from '../services/post-utils';
import { getCategoryIds } from '../store/categories/categories-selectors';
import { type NormalizedPost } from '../types';

export const FETCH_LAST_FEATURED_POST_REQUEST = 'lastFeaturedPost/FETCH_REQUEST';
export const FETCH_LAST_FEATURED_POST_SUCCESS = 'lastFeaturedPost/FETCH_SUCCESS';
export const FETCH_LAST_FEATURED_POST_FAILURE = 'lastFeaturedPost/FETCH_FAILURE';

export const fetchLastFeaturedPostRequest = createAction(FETCH_LAST_FEATURED_POST_REQUEST);
export const fetchLastFeaturedPostSuccess = createAction(
  FETCH_LAST_FEATURED_POST_SUCCESS,
  (payload: NormalizedPost) => payload,
);
const fetchLastFeaturedPostFailure = createAction(FETCH_LAST_FEATURED_POST_FAILURE);

type CompleteFetchLastFeaturedPostParams = Promise<HttpResponse<GetPostFeedPageResponse>>;

type CompleteFetchLastFeaturedPostReturnType = CompleteFetchLastFeaturedPostParams;

export const fetchLastFeaturedPost =
  (preFetch: boolean): FeedPageThunkAction =>
  (...params) => {
    const [dispatch, _, { httpClient }] = params;

    dispatch(fetchLastFeaturedPostRequest());

    const promise = httpClient.request(
      getPostFeedPage({
        type: FeedType.POST_LIST_WIDGET,
        page: 1,
        pageSize: 1,
        skipCount: true,
        postListWidgetOptions: {
          featuredOnly: true,
        },
      }),
    );

    return preFetch ? promise : completeFetchLastFeaturedPost(promise)(...params);
  };

export const completeFetchLastFeaturedPost =
  (
    promise: CompleteFetchLastFeaturedPostParams,
  ): FeedPageThunkAction<CompleteFetchLastFeaturedPostReturnType> =>
  async (dispatch, getState, { errorHandler }) => {
    const { withErrorHandler, getResolvedError } = errorHandler;

    try {
      const { data } = await withErrorHandler(() => promise, {
        errorCodesMap: {},
      });

      const normalizedPost = normalizePosts({
        posts: data?.postFeedPage?.posts?.posts,
        blogCategoryIds: getCategoryIds(getState()),
        origin: '/v3/posts',
      })[0];

      dispatch(fetchLastFeaturedPostSuccess(normalizedPost));
    } catch (err) {
      dispatch(fetchLastFeaturedPostFailure());
      const error = getResolvedError(err);
      throw error;
    }

    return promise;
  };
